import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import RadioButtonLabel from '../../molecules/labels/RadioButtonLabel';
import Span from '../../atoms/spans/Span';
import Image from '../../atoms/images/Image';
import Paragraph from '../../atoms/paragraphs/Paragraph';
import { Tooltip } from 'react-tooltip';
import CheckBoxLabel from '../../molecules/labels/CheckBoxLabel';

/**
 * PlanSelector component for selecting subscription plans
 * @param {object} props - React props object
 * @returns {React.ReactElement} PaymentMethodSelector component
 */
const PaymentMethodSelector = ({ intl, ...props }) => {
  const {
    paymentMethods,
    paymentMethodInfo,
    selectedMethod,
    selectedCycle,
    onChange,
    className = '',
    changePayment,
    setChangePayment,
  } = props;

  return (
    <div className={`d-flex flex-row ${className}`}>
      <div className='d-flex flex-column payment-method-selector w-100'>
        {paymentMethods.map((method, index) => (
          <div
            key={'method_' + index}
            className='d-flex flex-column align-items-start payment-method-option user-select-none'
          >
            <div className='d-flex flex-row w-100 align-items-center justify-content-between'>
              <div
                className='d-flex flex-row align-items-center'
                data-tooltip-id={
                  method.disabled ||
                  method.disabled_cycles?.includes(selectedCycle)
                    ? 'disabledPaymentMethod_' + method.id
                    : ''
                }
                data-tooltip-delay-hide={250}
              >
                <RadioButtonLabel
                  id={method.id}
                  className='checkbox round'
                  name='payment-method'
                  checked={selectedMethod.id === method.id}
                  onChange={() => onChange(method)}
                  value={method.id}
                  disabled={
                    method.disabled ||
                    method.disabled_cycles?.includes(selectedCycle)
                  }
                ></RadioButtonLabel>

                <div
                  data-testid={method.id + '_name'}
                  className={`d-flex flex-row payment-label ${
                    method.disabled ||
                    method.disabled_cycles?.includes(selectedCycle)
                      ? 'disabled'
                      : ''
                  }`}
                  onClick={() => onChange(method)}
                >
                  <Image
                    className='payment-icon'
                    src={method.label[1]}
                    style={{ width: 'auto', height: '3rem' }}
                  />
                  <div className='d-flex flex-row justify-content-between'>
                    {method.label[0] && (
                      <Span className='payment-name ms-2'>
                        {intl.messages['paymentMethod_' + method.id]}
                      </Span>
                    )}
                  </div>
                </div>
              </div>

              <Tooltip
                id={`disabledPaymentMethod_${method.id}`}
                className='tooltip'
                content={
                  method.disabled_cycles?.includes(selectedCycle)
                    ? intl.messages['disabledPaymentMethodTooltipCycle']
                    : intl.messages['disabledPaymentMethodTooltip']
                }
                place='bottom'
              />

              <div className='d-flex flex-row ms-auto'>
                {method.icons.map((icon, index) => (
                  <Image
                    className='payment-icon'
                    src={icon}
                    style={{ width: 'auto', height: '1.5rem' }}
                    key={index}
                  />
                ))}
              </div>
            </div>
            {(paymentMethodInfo === undefined &&
              selectedMethod.id === method.id &&
              method.description && (
                <Paragraph className='text-paragraph payment-description'>
                  {intl.messages[method.description]}
                </Paragraph>
              )) || <></>}

            {(paymentMethodInfo !== undefined &&
              paymentMethodInfo.type === 'CC' &&
              selectedMethod.id === method.id && (
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex'>
                    <Paragraph className='text-paragraph payment-description mb-3'>
                      <FormattedMessage
                        id='checkoutPaymentInfoCard'
                        values={{
                          card_type: paymentMethodInfo.card_type,
                          last_four: paymentMethodInfo.last_four,
                        }}
                      />
                    </Paragraph>
                    <Paragraph className='text-paragraph payment-description mb-3 ms-auto'>
                      <FormattedMessage
                        id='checkoutPaymentInfoExpirationDate'
                        values={{
                          expiration_date: paymentMethodInfo.expiration_date,
                        }}
                      />
                    </Paragraph>
                  </div>

                  <CheckBoxLabel
                    className='checkbox me-2'
                    onChange={(e) => setChangePayment(e.target.checked)}
                    checked={changePayment}
                  >
                    <Paragraph className='ms-2 my-0 text-paragraph payment-description'>
                      {intl.messages['checkoutPaymentInfoChangeCard']}
                    </Paragraph>
                  </CheckBoxLabel>
                </div>
              )) || <></>}
            <div className='d-flex divider'></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default injectIntl(PaymentMethodSelector);
